<common-navigation></common-navigation>

<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-6 col-lg-4">
            <div class="sign-up default-box long-form d-flex align-items-center">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-lg-4 col-xl-4 mx-auto side-nav" id="sign-up-sidenav">
                            <!-- Error Message -->
                            <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="error">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="error = !error">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                {{ errorMsg }}
                            </div>
                            <h3 class="display-4 box-title">Sign Up</h3> <br>
                            <p>Already have an account? <a routerLink="/sign-in">Sign In</a></p>
                            <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="firstName"
                                        [ngClass]="{'error': (submitted && signUpForm.invalid && f.firstName.invalid) || (f.firstName.dirty && f.firstName.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>First Name</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="lastName"
                                        [ngClass]="{'error': (submitted && signUpForm.invalid && f.lastName.invalid) || (f.lastName.dirty && f.lastName.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Last Name</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="email"
                                        formControlName="email"
                                        [ngClass]="{'error': (submitted && signUpForm.invalid && f.email.invalid) || (f.email.dirty && f.email.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Email</label>
                                </div>
                                <div class="md-input password mb-2">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="password"
                                        id="password-input"
                                        formControlName="password"
                                        [ngClass]="{'error': (submitted && signUpForm.invalid && f.password.invalid) || (f.password.dirty && f.password.invalid)}"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Password</label>
                                    <span class="show-password" (click)="showPassword()">
                                        <i class="fa fa-eye-slash" id="show-password-icon"></i>
                                    </span>
                                </div>
                                <div class="md-input">
                                  <input
                                    class="md-form-control"
                                    type="text"
                                    oninput="this.value = this.value.toUpperCase()"
                                    formControlName="voucher"
                                    (blur)="checkVoucherValue()"
                                    (focus)="pushlabelUp()"
                                    [ngClass]="{'error': (submitted && signUpForm.invalid && f.voucher.invalid) || (f.voucher.dirty && f.voucher.invalid)}"
                                  >
                                  <span class="highlight"></span>
                                  <span class="bar"></span>
                                  <label [style.top]="labelUp ? '-15px' :'0px'">Voucher (Optional)</label>
                                </div>
                                <!-- <div class="jumbotron p-3 mt-3 alert alert-warning alert-dismissible fade show password-notes"
                                    *ngIf="!showPasswordLengthError || !showPasswordLetterError || !showPasswordNumberError"
                                >
                                    <p *ngIf="!showPasswordLengthError">Password should contain 8 characters</p>
                                    <p *ngIf="!showPasswordLetterError">Password should contain 1 upper case letter</p>
                                    <p *ngIf="!showPasswordNumberError">Password should contain 1 decimal number</p>
                                </div> -->
                                <div class="jumbotron p-3 mt-3 alert alert-warning alert-dismissible fade show password-notes">
                                    <p>Password should contain 8 characters, 1 upper case letter and 1 decimal number</p>
                                </div>
                                <button type="submit" class="mt-5 mt-md-5 btn btn-primary btn-block btn-submit">
                                    Sign Up
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-lg-8 d-none d-lg-flex default-box bg-image"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>
